import React, { useEffect, useState } from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
import StatusComp from "../../components/StatusComp";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  dummyimage,
  edit_icon,
  eye_icon,
  green_icon,
  red_icon,
  user,
  view_icon,
} from "../../assets/imgs";
import { post, get } from "../../Services/ApiHandler";
import { URL as API } from "../../Services/Constant";
import AlreadyComPopup from "../../components/Popup/AlreadyComPopup";

const CompanyGenerate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const type = location?.state?.type;
  const givenpermissions = JSON.parse(localStorage.getItem("user_permission"));
  const [logo, setLogo] = useState();
  const [ownerImg, setOwnerImg] = useState();
  const [companyID, setCompanyID] = useState(location?.state?.data?.id);
  const [email_verified, setEmail_verified] = useState(0);
  const [fullData, setFullDate] = useState({});
  const [popup, setPopup] = useState(false);

  const createdAt = moment().format("DD-MM-YYYY");

  const comDataObj = {
    companyName: "",
    companyCode: "",
    person: "",
    email: "",
    mobile: "",
    password: "",
    confirmPassword: "",
    siteName: "",
    location: "",
    role: "",
  };

  const [comData, setComData] = useState(comDataObj);
  const [admindetails, setAdminDetails] = useState({});

  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);

  const [siteErrors, setSiteErrors] = useState({});
  const [emailCheckData, setEmailCheckData] = useState({});
  const [emailCheckFlag, setEmailCheckFlag] = useState(0);
  const [flagEmail, setFlagEmail] = useState(0);

  const [visible, setVisible] = useState(false);
  const [confVisible, setConfVisible] = useState(false);

  const [siteList, setSiteList] = useState([]);
  const [companyKnfRole, setCompanyKnfRole] = useState({});
  const [locList, setLoclist] = useState([]);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const getKfnRole = () => {
    get(API.COMPANY_ROLE_LIST)
      .then((res) => {
        if (res?.status == "success") {
          setCompanyKnfRole(res?.role);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getLocationList = () => {
    get(API.LOCATION_LIST)
      .then((res) => {
        if (res?.status == "success") {
          setLoclist(res?.data);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getView = () => {
    get(API.COMPANY_List_VIEW + location?.state?.data?.id)
      .then((res) => {
        let data = res?.data;
        setFullDate(data);
        if (data?.is_email_verified) {
          setEmail_verified(data?.is_email_verified);
        }
        if (data?.logo) {
          setLogo(data?.logo);
        }

        let ob = {
          companyName: "",
          companyCode: "",
          person: "",
          email: "",
          mobile: "",
          password: "",
          confirmPassword: "",
          siteName: "",
          location: "",
          is_email_verified: data?.is_email_verified,
        };

        if (data?.company_name) {
          ob.companyName = data?.company_name;
        }

        if (data?.company_code) {
          ob.companyCode = data?.company_code;
        }

        if (data?.name) {
          ob.person = data?.name;
        }

        if (data?.email) {
          ob.email = data?.email;
        }
        if (data?.phone) {
          ob.mobile = data?.phone;
        }
        if (data?.location) {
          ob.location = data?.location;
        }

        setComData(ob);
        if (data?.profile_image) {
          setOwnerImg(data?.profile_image);
        }
        setEmailCheckFlag(1);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getKfnRole();
    getLocationList();

    if (location?.state?.data?.id) {
      getView();
    }
  }, []);

  const validate = () => {
    const newErrors = {};
    const singaporeMobileRegex = /^[89]\d{7}$/;

    if (comData?.companyName?.length == 0)
      newErrors.companyName = "Company Name is required";
    if (comData?.companyCode?.length == 0)
      newErrors.companyCode = "Company Code is required";
    if (comData?.location?.length == 0)
      newErrors.location = "Location is required";
    if (comData?.email?.length == 0 || !emailRegex.test(comData?.email))
      newErrors.email = "Valid Email is required";
    // if (
    //   !comData?.mobile
    //   // || !singaporeMobileRegex.test(comData?.mobile)
    // ) {
    //   newErrors.mobile = "Enter valid 9-digit Singapore number";
    // }
    if (
      !comData?.mobile ||
      (comData?.mobile?.length !== 8 && comData?.mobile?.length !== 10)
    ) {
      newErrors.mobile = "Enter valid 8-digit or 10-digit mobile number";
    }
    if (comData?.person?.length == 0)
      newErrors.person = "Person Name is required";

    if (!companyID) {
      // if (comData?.password?.length == 0 || comData?.password.length < 6)
      //   newErrors.password = "Password must be at least 6 characters";
      // if (comData?.confirmPassword !== comData?.password)
      //   newErrors.confirmPassword = "Passwords do not match";
      // if (!logo) newErrors.logo = "Company Logo is required";
      // if (!ownerImg) newErrors.ownerImg = "Primary Person image is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // if (comData?.email?.length < 0) {
    //   setEmailCheckData({});
    // }

    if (name === "companyName" && value.trim().length > 50) {
      toast.error("Company name cannot exceed 50 characters.");
      return;
    }

    setComData((prev) => ({ ...prev, [name]: value }));

    // clear specific error while typing
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = () => {
    if (validate()) {
      const formdata = new FormData();
      formdata.append("name", comData?.person);
      formdata.append("company_name", comData?.companyName);
      formdata.append("company_code", comData?.companyCode);
      formdata.append("email", comData?.email);
      formdata.append("roles", companyKnfRole?.id);
      formdata.append("phone", comData?.mobile);
      // if (comData?.password) {
      //   formdata.append("password", comData?.password);
      // }
      // if (comData?.password_confirmation) {
      //   formdata.append(
      //     "password_confirmation",
      //     comData?.password_confirmation
      //   );
      // }
      formdata.append("location", comData?.location);
      if (logo?.name) {
        formdata.append("logo", logo);
      }
      if (ownerImg?.name) {
        formdata.append("profile_image", ownerImg);
      }

      if (companyID) {
        // formdata.append("_method", "PATCH");
        post(API.COMPANY_EDIT + companyID, formdata)
          .then((res) => {
            if (res?.status == "success") {
              toast.success(res?.message);
              navigate("/company");
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      } else {
        post(API.COMPANY_ADD, formdata)
          .then((res) => {
            if (res?.status == "success") {
              toast.success(res?.message);
              navigate("/company");
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
      //   console.log("Submit successful", comData);
    }
  };

  const handleLogoChange = (event) => {
    let image = event.target.files[0];
    if (image) {
      setLogo(image);
      setErrors((prev) => ({
        ...prev,
        logo: "",
      }));
    }
  };
  // console.log('logo', logo)

  const handlePrimaryImg = (event) => {
    let image = event.target.files[0];
    if (image) {
      setOwnerImg(image);
      setErrors((prev) => ({
        ...prev,
        ownerImg: "",
      }));
    }
  };

  const autoFetchData = (data) => {
    setEmailCheckData(data);
    let ob = {
      companyName: "",
      companyCode: "",
      person: "",
      email: "",
      mobile: "",
      password: "",
      confirmPassword: "",
      siteName: "",
      location: "",
    };

    if (data?.company?.id) {
      setCompanyID(data?.company?.id);
    }

    if (data?.company?.logo) {
      setLogo(data?.company?.logo);
    }

    if (data?.company?.name) {
      ob.companyName = data?.company?.name;
    }

    if (data?.company?.company_code) {
      ob.companyCode = data?.company?.company_code;
    }

    if (data?.user?.name) {
      ob.person = data?.user?.name;
    }

    if (data?.user?.email) {
      ob.email = data?.user?.email;
    } else {
      ob.email = comData?.email;
    }

    if (data?.user?.phone) {
      ob.mobile = data?.user?.phone;
    }
    if (data?.company?.location) {
      ob.location = data?.company?.location;
    }

    setComData(ob);
    if (data?.user?.profile_image) {
      setOwnerImg(data?.user?.profile_image);
    }
  };

  const emailCheck = () => {
    let formdata = new FormData();
    if (comData?.email?.length > 0) {
      formdata.append("email", comData?.email);
      post(API.EMAIL_CHECK, formdata)
        .then((res) => {
          setFlagEmail(0);
          if (res?.exists && location?.state?.type == "edit") {
            toast.error(res?.message);
            setEmailCheckFlag(0);
            let data = res?.userData?.[0];
            let emCheck = {
              ...data?.user,
              company: data?.company,
            };
            setAdminDetails(emCheck);
            if (emCheck?.id) {
              setPopup(true);
            } else {
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
            // } else if (res?.exists && res?.message?.includes("admin")) {
          } else if (
            res?.exists &&
            res?.message == "This email is already an admin."
          ) {
            toast.error(res?.message);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } else {
            setEmailCheckFlag(1);
            if (res?.userData?.length > 0) {
              let data = res?.userData?.[0];
              if (data?.user?.knf_type == 1) {
                autoFetchData(data);
              } else if (data?.user?.knf_type == null) {
                autoFetchData(data);
              } else {
                toast.error("Email ID already exists");
              }
            } else {
              let ob = {
                ...(location?.state?.type == "edit" ? comData : comDataObj),
                email: comData.email,
              };
              setComData(ob);
              setEmailCheckData({});
              if (location?.state?.type !== "edit") {
                toast("please enter all required fields");
              }
            }
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      toast.error("Please Enter Valid Email");
    }
  };

  const handleClosePopup = () => {
    setPopup(false);
    window.location.reload();
  };

  return (
    <div className="dashRightView">
      <StatusComp name={"Company"} type={type} />

      {popup && (
        <AlreadyComPopup
          setPopup={setPopup}
          locList={locList}
          admindetails={admindetails}
        />
      )}

      <div className="d-flex flex-wrap gap-5">
        <div className="col-md-5">
          <div className="d-flex w-100 ac-jb">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Primary Email ID<span className="text-danger">*</span>
            </p>
            {type == "edit" && (
              <p className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-12 mb-1 text-primary mx-2">
                {email_verified
                  ? "Email Verified"
                  : "Email Verification pending"}
              </p>
            )}
          </div>
          <div className="d-flex">
            <input
              className="input-box"
              name="email"
              value={comData?.email}
              onChange={(even) => {
                setFlagEmail(1);
                // handleChange(even)
                if (location?.state?.type == "edit") {
                  handleChange(even);
                  setEmailCheckFlag(1);
                } else {
                  setComData(() => ({
                    ...comDataObj,
                    email: even.target.value,
                  }));
                  setEmailCheckFlag(0);
                }
              }}
              type="email"
              placeholder="Primary Email id"
              // disabled={type == "edit" ? true : false}
            />
            {/* {email_verified == 0 && ( */}
            {/* {comData?.email?.length > 1 && ( */}
            <button
              className={`email_check_btn ${
                !emailRegex?.test(comData?.email) ? "opacity-50" : ""
              }`}
              disabled={
                comData?.email?.length == 0
                  ? true
                  : // : type == "edit"
                    // ? true
                    false
              }
              onClick={() => {
                if (location?.state?.type == "edit") {
                  if (fullData?.email == comData?.email) {
                    toast.error("Same Email Entered");
                  } else {
                    emailCheck();
                  }
                } else {
                  emailCheck();
                }
              }}
            >
              Check
            </button>
            {/* )} */}
          </div>
          {errors.email && <p className="err">{errors.email}</p>}
        </div>
        {/* {emailCheckFlag == 1 && (  )} */}
        <>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Company name<span className="text-danger">*</span>
            </p>
            <input
              className="input-box"
              name="companyName"
              value={comData?.companyName}
              onChange={handleChange}
              type="text"
              placeholder="Company name"
              disabled={
                emailCheckData?.company?.name
                  ? true
                  : emailCheckFlag == 0
                    ? true
                    : false
              }
            />
            {errors?.companyName && (
              <p className="err">{errors?.companyName}</p>
            )}
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Company Code<span className="text-danger">*</span>
            </p>
            <input
              className="input-box"
              name="companyCode"
              value={comData?.companyCode}
              onChange={handleChange}
              type="text"
              placeholder="Company Code"
              disabled={
                emailCheckData?.company?.company_code
                  ? true
                  : emailCheckFlag == 0
                    ? true
                    : false
              }
            />
            {errors?.companyCode && <p className="err">{errors.companyCode}</p>}
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary flex">
              Location<span className="text-danger">*</span>
            </p>
            <select
              name="location"
              value={comData?.location}
              onChange={handleChange}
              className="input-box"
              type="text"
              disabled={
                emailCheckData?.company?.location
                  ? true
                  : emailCheckFlag == 0
                    ? true
                    : false
              }
            >
              <option>Select Location</option>
              {locList?.map((item) => {
                return (
                  <option value={item?.id} key={item?.id}>
                    {item?.name}
                  </option>
                );
              })}
            </select>
            {errors.location && <p className="err">{errors.location}</p>}
          </div>
          {type == "add" && (
            <div className="col-md-5">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
                Company Logo
              </p>
              <span className="text-danger fs-12">
                JPG, JPEG, PNG only | Max size: 5MB
              </span>
              <input
                className="input-box"
                name="logo"
                onChange={handleLogoChange}
                type="file"
                placeholder="Company Logo"
                accept="image/*"
                disabled={
                  emailCheckData?.company?.logo
                    ? true
                    : emailCheckFlag == 0
                      ? true
                      : false
                }
              />
              {/* {errors.logo && <p className="err">{errors.logo}</p>} */}
            </div>
          )}

          {type != "add" && (
            <div className="col-md-5">
              <div className="mb-2">
                <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                  Company logo
                </p>
                <span className="text-danger fs-12">
                  JPG, JPEG, PNG only | Max size: 5MB
                </span>
              </div>

              {logo ? (
                <img
                  src={logo?.name ? URL.createObjectURL(logo) : logo}
                  alt=""
                  className="user"
                />
              ) : (
                <img src={user} alt="" className="user" />
              )}
              {type != "view" && (
                <>
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    id="edit-logo"
                    onChange={handleLogoChange}
                    disabled={
                      emailCheckData?.company?.logo
                        ? true
                        : emailCheckFlag == 0
                          ? true
                          : false
                    }
                  />

                  <button
                    disabled={
                      emailCheckData?.profile_url
                        ? true
                        : emailCheckFlag == 0
                          ? true
                          : false
                    }
                    onClick={() => document.getElementById("edit-logo").click()}
                    className="cust-btn"
                  >
                    <img src={edit_icon} alt="" className="ms-4 edit-btn" />
                  </button>
                </>
              )}
            </div>
          )}

          {type == "add" && (
            <div className="col-md-5">
              <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
                Primary person image
              </p>
              <span className="text-danger fs-12">
                JPG, JPEG, PNG only | Max size: 5MB
              </span>
              <input
                className="input-box"
                name="logo"
                onChange={handlePrimaryImg}
                type="file"
                placeholder="Company Logo"
                accept="image/*"
                disabled={
                  emailCheckData?.profile_url
                    ? true
                    : emailCheckFlag == 0
                      ? true
                      : false
                }
              />
              {/* {errors.ownerImg && <p className="err">{errors.ownerImg}</p>} */}
            </div>
          )}

          {type != "add" && (
            <div className="col-md-5">
              <div className="mb-2">
                <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                  Primary person image
                </p>
                <span className="text-danger fs-12">
                  JPG, JPEG, PNG only | Max size: 5MB
                </span>
              </div>

              <img
                src={
                  ownerImg
                    ? ownerImg?.name
                      ? URL.createObjectURL(ownerImg)
                      : ownerImg
                    : user
                }
                alt=""
                className="user"
              />
              {type !== "view" && (
                <>
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    id="edit-logo1"
                    onChange={handlePrimaryImg}
                  />

                  <button
                    disabled={
                      emailCheckData?.profile_url
                        ? true
                        : emailCheckFlag == 0
                          ? true
                          : false
                    }
                    onClick={() =>
                      document.getElementById("edit-logo1").click()
                    }
                    className="cust-btn"
                  >
                    <img src={edit_icon} alt="" className="ms-4 edit-btn" />
                  </button>
                </>
              )}
            </div>
          )}

          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Primary person<span className="text-danger">*</span>
            </p>
            <input
              className="input-box"
              name="person"
              value={comData?.person}
              onChange={handleChange}
              type="text"
              placeholder="Primary person"
              disabled={
                emailCheckData?.name ? true : emailCheckFlag == 0 ? true : false
              }
            />
            {errors.person && <p className="err">{errors.person}</p>}
          </div>

          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary flex">
              Primary Singapore Mobile number
              <span className="text-danger">*</span>
            </p>
            <input
              name="mobile"
              value={comData?.mobile}
              maxLength={8}
              onChange={handleChange}
              className="input-box"
              type="text"
              placeholder="+65 Mobile number"
              disabled={
                emailCheckData?.phone
                  ? true
                  : emailCheckFlag == 0
                    ? true
                    : false
              }
            />
            {errors.mobile && <p className="err">{errors.mobile}</p>}
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Roles<span className="text-danger">*</span>
            </p>
            <input
              className="input-box"
              name="roles"
              value={companyKnfRole?.name}
              onChange={handleChange}
              type="text"
              placeholder="Roles"
              disabled={true}
            />
          </div>
        </>

        {/* {type !== "view" && (
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Password
              {type !== "view" || type !== "edit" ? (
                <span className="text-danger">*</span>
              ) : (
                ""
              )}
            </p>
            <div className="input-box ac-jb ">
              <LockOutlinedIcon className="emial-icon" />
              <input
                name="password"
                value={comData?.password}
                onChange={handleChange}
                type={visible ? "text" : "password"}
                maxLength={20}
                placeholder="Password"
                disabled={emailCheckData?.company_id ?? false}
              />
              {!visible && (
                <img
                  src={eye_icon}
                  onClick={() => setVisible(!visible)}
                  className="eye-icon pointer mb-1"
                  alt=""
                />
              )}
              {visible && (
                <VisibilityIcon
                  onClick={() => setVisible(!visible)}
                  className="eye-icon "
                />
              )}
            </div>
            {errors.password && <p className="err">{errors.password}</p>}
          </div>
        )} */}
        {/* {type !== "view" && (
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Confirm Password{" "}
              {type !== "view" || type !== "edit" ? (
                <span className="text-danger">*</span>
              ) : (
                ""
              )}
            </p>
            <div className="input-box ac-jb">
              <LockOutlinedIcon className="emial-icon" />
              <input
                name="confirmPassword"
                value={comData?.confirmPassword}
                onChange={handleChange}
                type={confVisible ? "text" : "password"}
                maxLength={20}
                placeholder="Confirm Password"
                disabled={emailCheckData?.company_id ?? false}
              />
              {!confVisible && (
                <img
                  src={eye_icon}
                  onClick={() => setConfVisible(!confVisible)}
                  className="eye-icon pointer mb-1"
                  alt=""
                />
              )}
              {confVisible && (
                <VisibilityIcon
                  onClick={() => setConfVisible(!confVisible)}
                  className="eye-icon "
                />
              )}
            </div>
            {errors.confirmPassword && (
              <p className="err">{errors.confirmPassword}</p>
            )}
          </div>
        )} */}
      </div>
      <div className="d-flex ac-jb mt-5">
        <button
          onClick={() => navigate(-1)}
          className="back-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
        >
          Back
        </button>

        {(givenpermissions?.includes("CAN-Add-COMPANIES") ||
          givenpermissions?.includes("CAN-EDIT-COMPANIES")) &&
          type != "view" &&
          flagEmail == 0 && (
            <>
              {emailCheckData?.id ? (
                <button
                  onClick={handleSubmit}
                  className={` submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 ${
                    emailCheckData?.email == comData?.email ? "" : "opacity-50"
                  }`}
                  disabled={
                    emailCheckData?.email == comData?.email ? false : true
                  }
                >
                  {type == "edit" ? "Submit" : "Add"}
                </button>
              ) : (
                <button
                  onClick={handleSubmit}
                  className={`submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 ${
                    emailCheckFlag == 1 ? "" : "opacity-50"
                  }`}
                  disabled={emailCheckFlag == 1 ? false : true}
                >
                  {type == "edit" ? "Submit" : "Add"}
                </button>
              )}
            </>
          )}
      </div>
    </div>
  );
};

export default CompanyGenerate;
